import Joi from 'joi';
import { rutValidation } from '../../../../../../helpers/RutValidator';

export const schema = Joi.object({
  motiveClient: Joi.string()
    .min(3)
    .error(new Error('Debe ingresar una opción')),
  rut: rutValidation.rut().validateRut(),
  clientName: Joi.string()
    .min(3)
    .error(new Error('Debe ingresar su nombre completo.')),
  phone: Joi.string()
    .min(9)
    .max(9)
    .pattern(new RegExp(/^\d+$/))
    .error(new Error('El teléfono debe contener 9 dígitos.')),
  email: Joi.string()
    .email({ minDomainSegments: 2, tlds: {} })
    .error(new Error('Formato de correo inválido.')),
  paymentMethod: Joi.string()
    .min(4)
    .error(new Error('Medio pago es requerido')),
  bank: Joi.string().error(new Error('Banco es requerido')),
  accountNumber: Joi.string()
    .min(3)
    .error(new Error('Número de cuenta es requerido')),
  cancelAddress: Joi.string().min(3).error(new Error('Dirección es requerida')),
  comment: Joi.string()
    .trim()
    .min(10)
    .max(250)
    .error(new Error('El comentario debe tener entre 10 y 250 caracteres.')),
});
